export const REQUIRED_ERROR = 'is required';
export const INVALID_ERROR = 'is invalid'
export const CARD_NAME_TYPE = 'CARD_NAME;';
export const CARD_NUMBER_TYPE = 'CARD_NUMBER';
export const CARD_EXPIRY_TYPE = 'CARD_DATE';
export const CARD_SECURITY_CODE_TYPE = 'CARD_CVV';
export const CARD_POSTAL_CODE_TYPE = 'CARD_POSTAL_CODE';
export const CARD_NAME_TITLE =' CARD NAME';
export const CARD_NAME_SELECTOR = 'billingName';
export const CVV_NAME = 'card-cvv';
export const CLOVER_KEY: string = process.env.CLOVER_API_KEY || '';
export const CLOVER_SDK_URL = process.env.CLOVER_SDK_URL || '';
export const CLOVER_MERCHANT = process.env.CLOVER_MERCHANT_ID || '';
export const CLOVER_STYLES = {
  body: {
    fontFamily: 'Roboto, Open Sans, sans-serif',
    fontSize: '0.875rem',
  },
  input: {
    display: 'flex',
    'flex-direction': 'row',
    'justify-content': 'space-between',
    height: '3.625rem',
    padding: '0 1rem',
    'box-sizing': 'border-box',
    margin: '0.5rem 0',
    color: '#181831',
    '-moz-appearance': 'none',
    '-webkit-appearance':' none',
    'appearance': 'none',
    fontSize: '1rem',
    'background-color': '#F5F4F4',
    width: '100%',
  },
  'input::placeholder': {
    color: '#aaaaaa',
    'font-family': 'var(--ff-utility)',
    'font-size': '0.875rem'
  },
  '.brand': {
    top: '1.375rem',
    right:'.75rem',
  },
};

export const CLOVER_CVV_STYLES = {
  body: {
    fontFamily: 'Roboto, Open Sans, sans-serif',
    fontSize: '0.875rem',
  },
  input: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '3.25rem',
    padding: '0 1rem',
    boxSizing: 'border-box',
    color: '#181831',
    MozAppearance: 'none',
    WebkitAppearance: 'none',
    appearance: 'none',
    fontSize: '1rem',
    backgroundColor: '#F5F4F4',
    width: '100%',
  },
  'input::placeholder': {
    color: '#aaaaaa',
    'font-family': 'var(--ff-utility)',
    'font-size': '0.875rem'
  },
  '.brand': {
    top: '1.375rem',
    right:'.75rem',
  },
};
